<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ $t(title) }}
            <!-- {{data}} -->
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-container>
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1 pa-0"
                    v-model="data.name"
                    :label="$t('resorce.newPopup.name')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    v-model="data.R"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :rules="[rules.required]"
                    label="Round"
                    prefix="KM"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    class="ma-1"
                    v-model="data.number"
                    :rules="[rules.required]"
                    :label="$t('resorce.newPopup.phone')"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="ma-0 pa-0"
                  v-if="update != true"
                >
                  <v-autocomplete
                    :items="cities"
                    filled
                    :rules="[rules.required]"
                    :label="$t('resorce.newPopup.city')"
                    outlined
                    v-model="data.city"
                    :item-text="$i18n.locale == 'ar' ? 'ar_name' : 'en_name'"
                    item-value="id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <vuetify-google-autocomplete
                    ref="address"
                    id="map"
                    outlined
                    class="ma-1 pa-0"
                    classname="form-control"
                    v-on:placechanged="getAddressData"
                    :country="$cookies.get('code')"
                    :rules="[rules.required, rules.address]"
                    persistent-hint
                    :label="$t('resorce.newPopup.address')"
                    :hint="data.address"
                    :value="data.address"
                  >
                  </vuetify-google-autocomplete>
                </v-col>

                <v-col cols="12" class="ma-0 pa-0">
                  <v-radio-group v-model="data.collect_cash">
                    <v-radio
                      :label="$t('package.newpackage.supportCash')"
                      :value="1"
                      color="green"
                    ></v-radio>
                    <v-radio
                      :label="$t('package.newpackage.noCash')"
                      :value="0"
                      color="red"
                    ></v-radio>
                  </v-radio-group>

                  <v-divider></v-divider>

                  <span style="color: red">
                    {{
                      $t("resorce.newPopup.notAvailable_online_payment")
                    }}</span
                  >
                </v-col>
              </v-row></v-form
            >
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">
            {{ $t("btn.cancel") }}
          </v-btn>

          <v-btn
            color="primary"
            :dark="!clicked"
            @click.prevent="submit"
            :disabled="clicked"
          >
            {{ $t("btn.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import { mapState, mapGetters } from "vuex";
import cl from "@/services/place.js";
export default {
  data: () => {
    return {
      valid: true,
      // data: {},
      clicked: false,
      wrongAddress: null,
      rules: {
        required: null,
        address: null,
      },
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.address = () => !!this.data.address || this.$t("rules.address");
  },
  components: { VuetifyGoogleAutocomplete },
  props: {
    dialog: { type: Boolean, default: () => false },
    data: { type: Object, default: () => {} },
    update: { type: Boolean, default: () => true },
  },

  computed: {
    ...mapState(["cities"]),
    title() {
      return this.update == true
        ? "resorce.newPopup.update"
        : "resorce.newPopup.title";
    },
  },
  methods: {
    resetAddress() {
      this.data.address = null;
    },
    close() {
      if (this.update == false) this.$refs.form.reset();
      this.$emit("close-dialog", false);
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData, id) {
      this.data.address =
        addressData.route +
        "," +
        addressData.postal_code +
        " " +
        addressData.locality +
        ", " +
        addressData.country;
      this.data.lng = addressData.longitude;
      this.data.lat = addressData.latitude;
    },

    submit() {
      this.$refs.form.validate();
      if (this.valid == false) return;
      this.clicked = true;
      const payload = this.data;

      if (this.update == false) {
        cl.add(payload)
          .then((res) => {
            this.$refs.form.reset();
            this.$store.dispatch(
              "api/handleServiceException",
              { e: res },
              { root: true }
            );

            this.$emit("close-dialog", false);
            this.clicked = false;
          })
          .catch((err) => {
            this.$store.dispatch(
              "api/handleServiceException",
              { e: err },
              { root: true }
            );
            this.clicked = false;
          });
      } else {
        cl.update(payload)
          .then((res) => {
            //this.$refs.form.reset();
            this.$store.dispatch(
              "api/handleServiceException",
              { e: res },
              { root: true }
            );

            this.$emit("close-dialog", false);
            this.clicked = false;
          })
          .catch((err) => {
            this.$store.dispatch(
              "api/handleServiceException",
              { e: err },
              { root: true }
            );
            this.clicked = false;
          });
      }
    },
  },
};
</script>
